"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Providers_1 = require("./Providers");
exports.Providers = Providers_1.default;
function joinContext(contexts) {
    return {
        Provider: joinProvider(contexts),
        Consumer: joinConsumer(contexts),
        useValues: Array.isArray(contexts) ?
            function () { return contexts.map(function (context) { return React.useContext(context); }); } :
            function () {
                var result = {};
                for (var key in contexts) {
                    var context = contexts[key];
                    result[key] = React.useContext(context);
                }
                return result;
            },
    };
}
exports.joinContext = joinContext;
function joinProvider(contexts) {
    return (function (_a) {
        var value = _a.value, children = _a.children;
        var items = Array.isArray(contexts) ?
            ziparr(contexts, value) :
            zipobj(contexts, value);
        return items.reduce(function (prev, curr) {
            var context = curr[0], value = curr[1];
            var Provider = context.Provider;
            return React.createElement(Provider, { value: value }, prev || children);
        }, null);
    });
}
function joinConsumer(contexts) {
    if (Array.isArray(contexts)) {
        return (function (_a) {
            var children = _a.children;
            return contexts.reduce(function (prev, curr) {
                var Consumer = curr.Consumer;
                return function (values) { return React.createElement(Consumer, null, function (value) { return (prev || children)(__spreadArrays([value], values)); }); };
            }, null)([]);
        });
    }
    else {
        return (function (_a) {
            var children = _a.children;
            return Object.entries(contexts).reduce(function (prev, curr) {
                var key = curr[0], Consumer = curr[1].Consumer;
                return function (values) { return React.createElement(Consumer, null, function (value) {
                    var _a;
                    return (prev || children)(__assign(__assign({}, values), (_a = {}, _a[key] = value, _a)));
                }); };
            }, null)({});
        });
    }
}
function ziparr(a, b) {
    var result = [];
    var length = Math.min(a.length, b.length);
    for (var i = 0; i < length; ++i)
        result.push([a[i], b[i]]);
    return result;
}
function zipobj(a, b) {
    var result = [];
    for (var _i = 0, _a = Object.keys(a); _i < _a.length; _i++) {
        var key = _a[_i];
        result.push([a[key], b[key]]);
    }
    return result;
}
